/*
   Hook into setting changes in order to change layout.
*/
const group = store => next => action => {
    let result = next(action);

    return result
}

export default group;